import { collection, doc, getDoc, getDocs, orderBy, query, serverTimestamp, setDoc } from "firebase/firestore";
import { db } from "./firebase";
import { EXAM_AULAS_MOCK, ExamAulas, SubjectAulas, TopicAulas, AulaLink } from "../data/aulasMock";

export interface ExamAulasDoc extends ExamAulas {
  updatedAt?: any;
  createdAt?: any;
}

const coll = collection(db, "examAulas");

const normalize = (v: string) =>
  String(v || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .trim();

export const getExamAulasCatalog = async (): Promise<ExamAulasDoc[]> => {
  try {
    const q = query(coll, orderBy("updatedAt", "desc"));
    const snap = await getDocs(q);
    const docs = snap.docs.map((d) => ({ id: d.id, ...(d.data() as any) })) as ExamAulasDoc[];
    if (docs.length > 0) return docs;
  } catch (_) {}
  return EXAM_AULAS_MOCK;
};

export const getExamAulasById = async (examId: string): Promise<ExamAulasDoc | null> => {
  try {
    const ref = doc(db, "examAulas", examId);
    const snap = await getDoc(ref);
    if (snap.exists()) return { id: snap.id, ...(snap.data() as any) } as ExamAulasDoc;
  } catch (_) {}
  return EXAM_AULAS_MOCK.find((e) => e.id === examId) || null;
};

export const upsertExamAulas = async (payload: ExamAulasDoc): Promise<void> => {
  const ref = doc(db, "examAulas", payload.id);
  await setDoc(
    ref,
    {
      ...payload,
      updatedAt: serverTimestamp(),
      createdAt: payload.createdAt || serverTimestamp(),
    },
    { merge: true },
  );
};

export const addAulaToExamTopic = (
  exam: ExamAulasDoc,
  subjectName: string,
  topicName: string,
  aula: AulaLink,
): ExamAulasDoc => {
  const subjects = Array.isArray(exam.subjects) ? [...exam.subjects] : [];
  const sIdx = subjects.findIndex((s) => normalize(s.subject) === normalize(subjectName));

  if (sIdx === -1) {
    subjects.push({
      subject: subjectName,
      topics: [{ topic: topicName, aulas: [aula] }],
    });
  } else {
    const subj: SubjectAulas = { ...subjects[sIdx], topics: [...(subjects[sIdx].topics || [])] };
    const tIdx = subj.topics.findIndex((t) => normalize(t.topic) === normalize(topicName));
    if (tIdx === -1) {
      subj.topics.push({ topic: topicName, aulas: [aula] });
    } else {
      const topic: TopicAulas = { ...subj.topics[tIdx], aulas: [...(subj.topics[tIdx].aulas || [])] };
      topic.aulas.push(aula);
      subj.topics[tIdx] = topic;
    }
    subjects[sIdx] = subj;
  }

  return { ...exam, subjects };
};
